import React from "react";
import "./RecipeSuggestionCard.css";

/**
 * Card shown in the chat when the backend's recipe matcher identifies the
 * user's prompt as something a curated recipe handles better than ad-hoc
 * Claude generation.
 *
 * The user chooses:
 *   - Use the recipe (preferred) → jumps to Integrations with the recipe
 *     pre-selected, setup guide visible, Test Credentials button ready
 *   - Continue with AI → re-sends the same prompt with skipRecipeMatch=true
 *     so the backend falls through to normal generation
 */
export default function RecipeSuggestionCard({ match, onUseRecipe, onContinue }) {
  if (!match) return null;

  return (
    <div className="recipe-suggestion-card">
      <div className="recipe-suggestion-header">
        <span className="recipe-suggestion-emoji" aria-hidden>💡</span>
        <div className="recipe-suggestion-title">
          This looks like a <strong>{match.name}</strong> integration.
        </div>
      </div>

      <p className="recipe-suggestion-desc">{match.description}</p>

      <div className="recipe-suggestion-why">
        <span className="recipe-suggestion-why-label">Why this match: </span>
        <span className="recipe-suggestion-why-reason">{match.reason}</span>
      </div>

      <div className="recipe-suggestion-pitch">
        We have a curated recipe that validates your credentials before any code
        is written — it takes a few minutes and typically avoids the usual
        debugging loop.
      </div>

      <div className="recipe-suggestion-actions">
        <button
          className="recipe-suggestion-primary"
          onClick={() => onUseRecipe && onUseRecipe(match)}
        >
          Use the recipe <span className="recipe-suggestion-arrow">→</span>
        </button>
        <button
          className="recipe-suggestion-secondary"
          onClick={() => onContinue && onContinue()}
        >
          Continue with AI
        </button>
      </div>

      <div className="recipe-suggestion-footer">
        You can always find this in <strong>Integrations</strong> later.
      </div>
    </div>
  );
}
